import { render, staticRenderFns } from "./addrescuecenter.vue?vue&type=template&id=3b46219c&"
import script from "./addrescuecenter.vue?vue&type=script&lang=js&"
export * from "./addrescuecenter.vue?vue&type=script&lang=js&"
import style0 from "./addrescuecenter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports